// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPage-cls1_yVX","cls2":"MarketingPage-cls2_IEm MarketingPage-cls1_yVX"};